// export const serverUrl = "http://localhost:4000";

export const serverUrl = "https://dibuybe.onrender.com";
